import { httpGet, httpPost } from '@pressreader/services';

import {
    CheckoutResponse,
    ICheckoutRequest,
    IConfirmRequest,
    IPurchaseContextDto,
    IPurchaseDataDto,
    IPurchaseInfoDto,
    IPurchaseProductRequest,
    IPurchaseRequest,
} from './types';

const serviceBasePath = 'purchase';

function getPurchaseInfo(requestedContent: IPurchaseRequest): Promise<IPurchaseInfoDto> {
    return httpGet<IPurchaseInfoDto>(serviceBasePath, 'GetPurchaseInfo', requestedContent);
}

function getArchivePurchaseInfo(requestedContent: IPurchaseRequest): Promise<IPurchaseInfoDto> {
    return httpGet<IPurchaseInfoDto>(serviceBasePath, 'GetArchivePurchaseInfo', requestedContent);
}

function addProductToBasket(product: IPurchaseProductRequest): Promise<boolean> {
    return httpPost(serviceBasePath, 'AddToBasket', JSON.stringify(product), {
        contentType: 'application/json',
    });
}

function getPurchaseContext(requestedContent?: IPurchaseRequest): Promise<IPurchaseContextDto> {
    return httpGet<IPurchaseContextDto>(serviceBasePath, 'GetPurchaseContext', requestedContent);
}

function getPurchaseData(orderId: string): Promise<IPurchaseDataDto> {
    return httpGet<IPurchaseDataDto>(serviceBasePath, orderId);
}

function checkout(requestedContent?: ICheckoutRequest): Promise<CheckoutResponse> {
    return httpPost(serviceBasePath, 'Checkout', requestedContent, { disableRetry: true });
}

function confirm(requestedContent: IConfirmRequest): Promise<void> {
    return httpPost(serviceBasePath, 'Confirm', JSON.stringify(requestedContent), {
        contentType: 'application/json',
    });
}

function checkPendingOrder(orderId: string): Promise<CheckoutResponse> {
    return httpGet<CheckoutResponse>(serviceBasePath, `pending-order/${orderId}`);
}

export { addProductToBasket, checkout, checkPendingOrder, confirm, getArchivePurchaseInfo, getPurchaseContext, getPurchaseData, getPurchaseInfo };
